export const TaiyuanForeignLanSchoolId = 1100108001;



// WEBPACK FOOTER //
// ./src/common/constant.js